import React from 'react'
import styles from './school-details-group-addon.styles'
import injectSheet from 'react-jss'
import FormRow from '../../../shared/details/form-row/form-row'
import FormCell from '../../../shared/details/form-cell/form-cell'
import FormLabel from '../../../shared/details/form-label/form-label'
import FormInput from 'pobble-components/dist/form-elements/form-input'
import { Formik } from 'formik'
import Button from 'pobble-components/dist/button'
import FormSelect from 'pobble-components/dist/form-elements/form-select'

const SchoolDetailsGroupAddon = ({
  classes,
  onSubmit,
  onUnset,
  id,
  subscriptionIds,
  subscriptions
}) => (
  <div>
    {id && (
      <Formik
        onSubmit={onSubmit}
        initialValues={{
          subscriptionId: '',
          plan: ''
        }}>
        {formikProps => {
          const {
            values,
            handleBlur,
            handleChange,
            handleSubmit,
            isValid,
            touched,
            errors
          } = formikProps
          return (
            <form onSubmit={handleSubmit}>
              <FormRow>
                <FormCell>
                  <FormLabel>School group addons</FormLabel>
                  <FormInput
                    name="subscriptionId"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.subscriptionId}
                    placeholder={'Ex: 16BjhvSLzbeHgTN7'}
                    validationError={
                      touched.subscriptionId && errors.subscriptionId
                    }
                  />
                </FormCell>
                <FormCell>
                  <FormSelect
                    name="plan"
                    value={values.plan}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    validationError={
                      values.plan !== '' && touched.plan && errors.plan
                    }>
                    <option value="">-</option>
                    <option value="pobble-school-a">
                      T&L (pobble-school-a)
                    </option>
                    <option value="pobble-school-b">
                      Moderation (pobble-school-b)
                    </option>
                    <option value="pobble-school-c">
                      Moderation Central Account (pobble-school-c)
                    </option>
                    <option value="pobble-school-d">
                      Statutory Assessment Service Contract (pobble-school-d)
                    </option>
                  </FormSelect>
                </FormCell>
                <FormCell>
                  <Button disabled={!isValid} type="submit" tall>
                    Assign group subscription ID
                  </Button>
                </FormCell>
              </FormRow>
              {subscriptionIds && subscriptionIds.length > 0 && (
                <FormRow>
                  <FormCell>
                    <FormLabel>
                      Currently assigned group subscriptions:
                    </FormLabel>
                    <ul>
                      {subscriptionIds.map(subscriptionId => (
                        <li key={subscriptionId} id={subscriptionId}>
                          {subscriptionId}
                        </li>
                      ))}
                    </ul>
                  </FormCell>
                </FormRow>
              )}

              {subscriptions && subscriptions.length > 0 && (
                <FormRow>
                  <FormCell>
                    <FormLabel>
                      Currently assigned school group subscriptions:
                    </FormLabel>
                    <ul>
                      {subscriptions.map(subscription => (
                        <li
                          key={subscription.subscription_id}
                          id={subscription.subscription_id}>
                          <ul>
                            {Object.keys(subscription).map(key => (
                              <li>
                                {key}:{' '}
                                {subscription[key] &&
                                  subscription[key].toString()}
                              </li>
                            ))}
                          </ul>
                        </li>
                      ))}
                    </ul>
                  </FormCell>
                </FormRow>
              )}
            </form>
          )
        }}
      </Formik>
    )}
  </div>
)

export default injectSheet(styles)(SchoolDetailsGroupAddon)
